//#region src/utils/safeCallback.ts
function safeCallback(callback, ...args) {
	try {
		return callback?.(...args);
	} catch (e) {
		console.error(e);
	}
}
//#endregion
export { safeCallback };
